// Keeps the screen on while a guide session runs (AV-43: phones locked after a
// few minutes of talking without a touch). Uses the Screen Wake Lock API — no
// user gesture needed, unlike the video trick in common/utils/no-sleep.js, so it
// works after the lead form and mic prompt. The browser drops the lock when the
// tab is hidden; it is taken again when the visitor comes back.
export default class ScreenWakeLock {
  constructor() {
    this._lock = null;
    this._wanted = false;
    this._onVisible = () => {
      if (this._wanted && document.visibilityState === 'visible' && !this._lock) this._request();
    };
  }

  static supported() {
    return typeof navigator !== 'undefined' && !!(navigator.wakeLock && navigator.wakeLock.request);
  }

  enable() {
    if (this._wanted || !ScreenWakeLock.supported()) return;
    this._wanted = true;
    document.addEventListener('visibilitychange', this._onVisible);
    this._request();
  }

  disable() {
    if (!this._wanted) return;
    this._wanted = false;
    document.removeEventListener('visibilitychange', this._onVisible);
    const lock = this._lock;
    this._lock = null;
    if (lock) lock.release().catch(() => {});
  }

  async _request() {
    try {
      const lock = await navigator.wakeLock.request('screen');
      if (!this._wanted) { lock.release().catch(() => {}); return; }
      this._lock = lock;
      lock.addEventListener('release', () => { if (this._lock === lock) this._lock = null; });
    } catch (err) {
      console.warn('[avatar] screen wake lock unavailable:', err && err.name);
    }
  }
}
